<div class="dialog" role="document" aria-labelledby="manage-user-title">
  <div class="dialog-header">
    <div class="title-block">
      <span class="dialog-title" id="manage-user-title">Manage access — {{ data.name }}</span>
      @if(access){
      <p class="dialog-subtitle">
        {{ access.userName }} · {{ access.isRestricted ? 'Restricted' : 'Active' }}
      </p>
      }
    </div>
    @if(canAct()){
    <button type="button" class="ac-primary-btn header-btn" [disabled]="isLoading" [matMenuTriggerFor]="addMenu">Add ▾</button>
    <mat-menu #addMenu="matMenu" class="ac-menu-panel" xPosition="before">
      <button mat-menu-item type="button" (click)="addRole()">Add role</button>
      <button mat-menu-item type="button" (click)="addPermission()">Add permission</button>
    </mat-menu>
    }
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="search-row">
    <div class="field">
      <label class="field-label" id="manage-role-filter-label">Role</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select
          aria-labelledby="manage-role-filter-label"
          panelClass="ac-select-panel"
          [disableOptionCentering]="true"
          [formControl]="roleFilter"
        >
          <mat-option [value]="''">All roles</mat-option>
          @for(r of roleOptions(); track r.roleKey){
          <mat-option [value]="r.roleKey">{{ r.roleName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <label class="field-label" for="manage-permission-search">Search permission</label>
      <input id="manage-permission-search" type="text" class="text-box-active" placeholder="View or permission" [formControl]="permissionSearch" />
    </div>
  </div>

  @if(access && canManageUsers && !access.canManage){
  <p class="notice">{{ access.isSelf ? 'This is your own account — your access is shown read-only.' : 'This user holds a role at or above your own, so their access is shown read-only.' }}</p>
  }

  <div class="access-list">
    @for(est of filteredEstablishments(); track placeKey(est)){
    <section class="est-block">
      <header class="est-header">
        <div class="est-title">
          <span class="est-name">{{ est.name || ('Establishment #' + est.establishmentId) }}</span>
          @if(est.code){ <span class="est-code">{{ est.code }}</span> }
        </div>
        @if(canRemove(est)){
        <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="removeFromEstablishment(est)">
          Remove from establishment
        </button>
        }
      </header>

      @for(role of est.roles; track role.suremId){
      <div class="role-block" [class.inactive]="!role.isActive">
        <div class="role-row">
          <button
            type="button"
            class="role-toggle"
            [attr.aria-expanded]="isExpanded(role.suremId)"
            (click)="toggleExpanded(role.suremId)"
          >
            <span class="chevron" aria-hidden="true">{{ isExpanded(role.suremId) ? '▾' : '▸' }}</span>
            <span class="role-name" id="role-name-{{ role.suremId }}">{{ role.roleName }}</span>
            <span class="role-count">{{ permissionCount(role) }} active permission{{ permissionCount(role) === 1 ? '' : 's' }}</span>
            @if(role.validUntil){ <span class="role-count">· until {{ role.validUntil }}</span> }
          </button>
          <div class="switch-cell">
            <span class="switch-label">{{ role.isActive ? 'Active' : 'Inactive' }}</span>
            <button
              type="button"
              class="ac-switch"
              role="switch"
              [class.on]="role.isActive"
              [attr.aria-checked]="role.isActive"
              [attr.aria-labelledby]="'role-name-' + role.suremId"
              [disabled]="isLoading || !canAct(role)"
              (click)="toggleRole(role)"
            ></button>
          </div>
        </div>

        @if(isExpanded(role.suremId)){
        <div class="views-panel">
          @for(view of filteredViews(role); track view.viewName){
          <div class="view-block">
            <div class="view-row">
              <span class="view-label" id="view-label-{{ role.suremId }}-{{ view.viewName }}">{{ view.viewLabel || view.viewName }}</span>
              <button
                type="button"
                class="ac-switch"
                role="switch"
                [class.on]="isViewOn(view)"
                [attr.aria-checked]="isViewOn(view)"
                [attr.aria-labelledby]="'view-label-' + role.suremId + '-' + view.viewName"
                [disabled]="isLoading || !canAct(role)"
                (click)="toggleView(role, view)"
              ></button>
            </div>
            <ul class="perm-list">
              @for(p of view.permissions; track p.supdId){
              <li class="perm-row" [class.inactive]="!p.isActive">
                <span class="perm-name" id="perm-name-{{ p.supdId }}">{{ p.permLabel || p.permission }}</span>
                <span class="perm-meta">
                  {{ p.fromRole ? 'Role default' : 'Added for this user' }}
                  @if(p.validUntil){ · until {{ p.validUntil }} }
                </span>
                <button
                  type="button"
                  class="ac-switch"
                  role="switch"
                  [class.on]="p.isActive"
                  [attr.aria-checked]="p.isActive"
                  [attr.aria-labelledby]="'perm-name-' + p.supdId"
                  [disabled]="isLoading || !canAct(role)"
                  (click)="togglePermission(role, p)"
                ></button>
              </li>
              }
            </ul>
          </div>
          } @empty {
          <p class="empty-note">{{ permissionSearch.value ? 'No permissions match the search.' : 'This role has no permissions.' }}</p>
          }
        </div>
        }
      </div>
      }
    </section>
    } @empty {
    @if(!isLoading){
    <p class="empty-note">{{ roleFilter.value ? 'The user does not hold that role here.' : 'No roles at the establishments you manage.' }}</p>
    }
    }
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
